const HowItWorksContent = [
    {
        icon: 'location',
        text: 'Our team are <span class="semi-bold">searching our database</span> to find the perfect Financial Adviser for you.',
    },
    {
        icon: 'bubbles',
        text: '<span class="semi-bold">The chosen Financial Adviser will be in touch</span> to discuss your request.',
    },
    {
        icon: 'tick',
        text: 'If you <span class="semi-bold">find a Financial Adviser that\'s right for you</span>, let them do what they do best!',
    },
];

export default HowItWorksContent;
